import React from 'react';
import { TQuoteType } from '../app/Pages/Quote/models';
import { JSONSchemaProp } from '../models';

export const QuoteContext = React.createContext<{
  quoteType?: TQuoteType,
  travelProductsSchema: JSONSchemaProp,
  motorProductsSchema: JSONSchemaProp,
  borderProductsSchema: JSONSchemaProp,
  assistanceProductsSchema: JSONSchemaProp,
  propertyProductsSchema: JSONSchemaProp,

  motorInsurersSchema: JSONSchemaProp,
  travelInsurersSchema: JSONSchemaProp,
  borderInsurersSchema: JSONSchemaProp,
  assistanceInsurersSchema: JSONSchemaProp,
  propertyInsurersSchema: JSONSchemaProp,

  travelProducts: string[],
  motorProducts: string[],
  borderProducts: string[],
  assistanceProducts: string[],
  propertyProducts: string[],

  motorInsurers: string[],
  travelInsurers: string[],
  borderInsurers: string[],
  assistanceInsurers: string[],
  propertyInsurers: string[],
}>({
  quoteType: undefined,
  travelProductsSchema: {},
  motorProductsSchema: {},
  borderProductsSchema: {},
  assistanceProductsSchema: {},
  propertyProductsSchema: {},

  motorInsurersSchema: {},
  travelInsurersSchema: {},
  borderInsurersSchema: {},
  assistanceInsurersSchema: {},
  propertyInsurersSchema: {},

  travelProducts: [],
  motorProducts: [],
  borderProducts: [],
  assistanceProducts: [],
  propertyProducts: [],

  motorInsurers: [],
  travelInsurers: [],
  borderInsurers: [],
  assistanceInsurers: [],
  propertyInsurers: [],
});
